import AdminAppCardWrapper from "../../Apps/AdminAppChild/AdminAppCardWrapper";
import AdminAppContainer from "../../Apps/AdminAppChild/AdminAppContainer";

const NoSubPages = () => {
  return (
    <AdminAppContainer>
      <AdminAppCardWrapper>
        No SubPage is Associated to this Page.
      </AdminAppCardWrapper>
    </AdminAppContainer>
  );
};

export default NoSubPages;
